export default __webpack_public_path__ + "static/media/high.3dfbba9f.jpg";